// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"CardOfferRadioFieldArray_fieldset__3GGAU","legend":"CardOfferRadioFieldArray_legend__37EEY"};